import {isEmpty} from "@pg-mono/nodash";

import {OfferType} from "../../offer/types/OfferType";

export const calculateNewOfferTypeArray = (currentTypes: OfferType[], toggleType: OfferType): OfferType[] => {
    if (toggleType === OfferType.COMMERCIAL) {
        // for commercial click we either return flat + house or commercial
        return currentTypes.includes(OfferType.COMMERCIAL) ? [] : [OfferType.COMMERCIAL];
    }
    // flat or house click
    if (!isEmpty(currentTypes)) {
        // when current type is present we return single (toggled) type (if current is commercial) or flat + house (if current is flat or house)
        return currentTypes.includes(OfferType.COMMERCIAL) ? [toggleType] : [];
    }
    // for empty list we return reverse type between flat and house
    return toggleType === OfferType.FLAT ? [OfferType.HOUSE] : [OfferType.FLAT];
};
import {isEmpty} from "@pg-mono/nodash";

import {OfferType} from "../../offer/types/OfferType";

export const calculateNewOfferTypeArray = (currentTypes: OfferType[], toggleType: OfferType): OfferType[] => {
    if (toggleType === OfferType.COMMERCIAL) {
        // for commercial click we either return flat + house or commercial
        return currentTypes.includes(OfferType.COMMERCIAL) ? [] : [OfferType.COMMERCIAL];
    }
    // flat or house click
    if (!isEmpty(currentTypes)) {
        // when current type is present we return single (toggled) type (if current is commercial) or flat + house (if current is flat or house)
        return currentTypes.includes(OfferType.COMMERCIAL) ? [toggleType] : [];
    }
    // for empty list we return reverse type between flat and house
    return toggleType === OfferType.FLAT ? [OfferType.HOUSE] : [OfferType.FLAT];
};
